import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { post, del } from '../../utils/api';
import useApi from '../../hooks/useApi';
import Form from '../common/Form';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { compare } from '../../utils/categories';
const MAIN_LIMIT = 3; // Захардкожено максимальное число основных категорий доступных для выбора
//
// Компонент выводит списки категорий экспонента для редактирования
//
const ExhibitorEditCategories = () => {
	const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const lang = i18n.language;
    const auth = useSelector(state => state.auth);
    const exhibitor = useSelector(state => state.exhibitor);
    const [ addon, setAddon ] = useState([]);
    const [ admin, setAdmin ] = useState([]);
    const [ folders, setFolders ] = useState([]);
    const [ orphans, setOrphans ] = useState([]);
    // eslint-disable-next-line
    const [ params, setParams ] = useState({ event: exhibitor.event._id });
    const [ data, error, isLoading ] = useApi({ type: 'get', method: '/categories/', params });

    // Разбираем список категорий по типам и отмечаем какие выбраныs
    useEffect(() => {
        if(!exhibitor || !data) return;

        const main  = [];
        const addon = [];
        const admin = [];
        
        data.categories.forEach(item => {
            if(exhibitor.categories.find(cat => cat._id === item._id)) {
                item.checked = true;
            } else {
                item.checked = false;
            }

            item.status = '';

            switch(item.type) {
                case 'admin':
                    admin.push(item);
                    break;
                case 'addon':
                    addon.push(item);
                    break;
                default:
                    main.push(item);
                    break;
            }
        });

        setAddon(addon);
        setAdmin(admin);

        const folders = [];
        const orphans = [];

        main.forEach(cat => {
            if(cat.is_folder) folders.push({ ...cat, categories: [] });
            else if(!cat.folder) orphans.push(cat);
        });

        main.forEach(cat => {
            if(cat.is_folder || !cat.folder) return;
            const folder = folders.find(f => f._id === cat.folder);
            if(!folder) return;
            folder.categories.push(cat);
        });

        folders.sort((a, b) => compare(a, b, lang));
        orphans.sort((a, b) => compare(a, b, lang));
        setFolders(folders);
        setOrphans(orphans);

    }, [ exhibitor, data, lang ]);

    // При изменении выбора любой кроме основной категории будет вызвана эта функция
    const update = (category, list, setList) => {
        const newList = [ ...list ];
        const index = newList.findIndex(c => c._id === category._id);
        if(index < 0) return;
        newList[index] = category;
        setList(newList);
    };

    // При изменении выбора основной категории все немного сложнее
    const updateFolders = (category) => {
        const newList = [ ...folders ];
        for(let i = 0; i < newList.length; i ++) {
            const folder = newList[i];
            const index = folder.categories.findIndex(c => c._id === category._id);
            if(index < 0) continue;
            folder.categories[index] = category;
            break;
        }
        setFolders(newList);
    };

    return (
    <div>
        <h1>{t('exhibitoredit.title_categories')}</h1>
        <div
            style={{margin:'2rem 0'}}
            dangerouslySetInnerHTML={
                {__html: t('exhibitoredit.subtitle_categories', { 'interpolation': {'escapeValue': false} })}
            }
        />
        {error && <div className='error'>{t(error)}</div>}
        {isLoading && <span>{t('common.loading')}</span>}
        
        <CategoryMain
            folders={folders}
            orphans={orphans}
            updateFolders={updateFolders}
            updateOrphans={category => update(category, orphans, setOrphans)}
        />

        <CategoryOther
            list={addon}
            header='eventview.cataddon'
            noitems='eventview.nocataddon'
            update={category => update(category, addon, setAddon)}
        />

        {(auth.user.role === 'root' || auth.user.role === 'admin') &&
        <CategoryOther
            list={admin}
            header='eventview.catadmin'
            noitems='eventview.nocatadmin'
            hint='category.admin_hint'
            update={category => update(category, admin, setAdmin)}
        />}
        
        <div className='p'>
            <div className='Link'
                onClick={() => navigate('/cabinet/exhibitorview/' + exhibitor._id)}
            >
                <Icon icon={faArrowLeft}/>
                <span>{t('common.back')}</span>
            </div>
        </div>
        
    </div>
	);
};
//
// Выводит основную категорию
//
const CategoryMain = ({ folders, orphans, updateFolders, updateOrphans }) => {
	const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const [ count, setCount ] = useState(0);

    // Вычислим сколько уже отмечено категорий
    useEffect(() => {
        let count = 0;
        orphans.forEach(item => { if(item.checked) count ++; });
        folders.forEach(folder => {
            folder.categories.forEach(item => { if(item.checked) count ++; })
        });
        setCount(count);
    }, [ folders, orphans ]);

    // Возвращает возможен ли выбор категории
    const disabled = (category) => {
        if(category.checked) return false;
        if(count >= MAIN_LIMIT) return true;
    };

    return (
    <Form>
        <fieldset>
            <legend>{t('eventview.catmain')}</legend>
    
            {(folders.length > 0 || orphans.length > 0) &&
            <div>
                {folders.map(item => (
                    <div key={item._id} style={{ marginTop: '.5rem' }}>
                        <b>{item.name[lang]}</b>
                        <CategoryList
                            list={item.categories}
                            disabled={disabled}
                            update={updateFolders}
                        />
                    </div>
                ))}
                {orphans.length > 0 &&
                <div style={{ marginTop: '.5rem' }}>
                    <b>{t('eventview.nofolder')}</b>
                    <CategoryList
                        list={orphans}
                        disabled={disabled}
                        update={updateOrphans}/>
                </div>}
            </div>}

            {(folders.length === 0 && orphans.length === 0) && <div>{t('eventview.nocatmain')}</div>}
        </fieldset>
    </Form>
    );
};
//
// Выводит список addon или admin
//
const CategoryOther = ({ list, header, noitems, hint, update }) => {
    const { t } = useTranslation();

    // Возвращает возможен ли выбор категории
    // Для категорий отличныйх от основной он всегда возможен
    const disabled = (category) => {
        return false;
    };

    return(
    <Form>
        <fieldset>
            <legend>{t(header)}</legend>
            {list.length ? <CategoryList list={list} disabled={disabled} update={update}/> : <div>{t(noitems)}</div>}
            {hint && <strong>{t(hint)}</strong>}
        </fieldset>
    </Form>
    );
};
//
// Выводит один из списков категорий
//
const CategoryList = ({ list, disabled, update }) => {
	const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const exhibitor = useSelector(state => state.exhibitor);
    const [ isLoading, setIsLoading ] = useState(false);
    const [ sorted, setSorted ] = useState([]);

    useEffect(() => {
        list.sort((a, b) => compare(a, b, lang));
        setSorted(list);
    }, [ list, lang ]);

    const onChange = async (category) => {
        if(disabled(category) || isLoading) return;
        const newCategory = { ...category };
        setIsLoading(true);

        let result;
        if(category.checked) {
            result = await del('/c2e/', { category: category._id, exhibitor: exhibitor._id });
        } else {
            result = await post('/c2e/', { category: category._id, exhibitor: exhibitor._id });
        }

        if(result.error) {
            newCategory.status = <span className='error'> - {t(result.error)}</span>;
        } else {
            newCategory.status = <span className='success'> - {t('common.noerror')}</span>;
            newCategory.checked = !category.checked;
        }
        setIsLoading(false);
        update(newCategory);
    };

    return(
    <React.Fragment>            
        {sorted.map(category =>
        <div className='Form-row' key={category._id}>
            <input
                id={category._id}
                type='checkbox'
                checked={category.checked}
                disabled={disabled(category) || isLoading}
                onChange={e => onChange(category)}
            />
            <label
                htmlFor={category._id}
                className={disabled(category) || isLoading ? 'disabled' : ''}
            >
                {category.name[lang]}
                <small>{isLoading ? ` - ${t('common.loading')}` : category.status}</small>
            </label>
        </div>)}
    </React.Fragment>
    );
};

export default ExhibitorEditCategories;
